var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"7"}}),_c('v-col',{attrs:{"cols":"5"}},[_c('div',{staticClass:"text-right display-2"},[_vm._v(" "+_vm._s(_vm.localMoney(_vm.total))+" "+_vm._s(_vm.currency)+" ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }